import { type Common } from './common.js';
import {
  type FlowRunTaskEvent,
  type FlowRunTaskEventFindAllParams,
} from './models/flowRunTaskEvent.js';

export class API {
  common: Common;
  baseEndpoint = '/flow-runs/task-events';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams: FlowRunTaskEventFindAllParams): Promise<FlowRunTaskEvent[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
